/*eslint-disable*/
import React, { Component } from 'react'
import { Container, Header, Grid, Button, Icon, Segment } from 'semantic-ui-react'
import moment from 'moment'
export default class InvoiceInfo extends Component {
    handleDoc = (e, data) => {
        // console.log(data.dataLink)
        window.open(`${data.dataLink}`, '_blank')
    }
    render() {
        if (this.props.getBillInfo.jb_invoice == null) {
            return (
                <>
                </>
            )
        } else {
            return (
                <React.Fragment>
                    <Segment hidden={this.props.hideDiv} >
                        {this.props.getBillInfo.map((object, index) => (
                            <Container fluid>
                                <Header as="label" size="small" className="p-bold-500" color="blue">Bill Details</Header>
                                <Grid centered columns="4">
                                    <Grid.Row>
                                        <Grid.Column>
                                            <Header as="p" color="grey" size="tiny" className="p-bold-500">Quotation Number</Header>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Header as="p" size="tiny" className="p-bold-500">{object.jb_invoice ? object.jb_invoice.quotationNo : 'N/A'} <Button disabled={object.jb_invoice.quotationDoc === null ? true : false} onClick={this.handleDoc} className="p-1 w3-small" dataLink={object.jb_invoice ? object.jb_invoice.quotationDoc : ''} basic icon color="blue"> <Icon name="download" /></Button></Header>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Header as="p" color="grey" size="tiny" className="p-bold-500">Amount</Header>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Header as="p" size="tiny" className="p-bold-500">{object.jb_invoice.quotationAmt ? object.jb_invoice.quotationAmt : 'N/A'}</Header>
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Grid.Column>
                                            <Header as="p" size="tiny" color="grey" className="p-bold-500">Bill Number</Header>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Header as="p" size="tiny" className="p-bold-500">{object.jb_invoice.quotationNo ? object.jb_invoice.quotationNo : 'N/A'}</Header>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Header as="p" size="tiny" color="grey" className="p-bold-500">Bill Date</Header>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Header as="p" size="tiny" className="p-bold-500">{object.jb_invoice.invoiceDate ? moment(object.jb_invoice.invoiceDate, "YYYY-MM-DD").format('DD-MM-YYYY') : 'N/A'}</Header>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Container>
                        ))}
                    </Segment>
                </React.Fragment>
            )
        }

    }
}
